import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const RealEstateQuestionnaire = ({ 
  realEstateTrack, 
  onRealEstateTrackChange,
  propertyTypes,
  onPropertyTypesChange,
  transactionVolume,
  onTransactionVolumeChange
}) => {
  const realEstateTrackOptions = [
    { value: 'development', label: 'Real Estate Development', description: 'Land acquisition, project development' },
    { value: 'property-management', label: 'Property Management', description: 'Asset management, operations' },
    { value: 'commercial', label: 'Commercial Real Estate', description: 'Leasing, brokerage, investment' }
  ];

  const developmentPropertyTypes = [
    { id: 'residential-dev', label: 'Residential Development' },
    { id: 'commercial-dev', label: 'Commercial Development' },
    { id: 'mixed-use-dev', label: 'Mixed-Use Development' },
    { id: 'industrial-dev', label: 'Industrial Development' },
    { id: 'land-acquisition', label: 'Land Acquisition' },
    { id: 'redevelopment', label: 'Redevelopment Projects' }
  ];

  const propertyManagementTypes = [
    { id: 'residential-pm', label: 'Residential Properties' },
    { id: 'commercial-pm', label: 'Commercial Properties' },
    { id: 'retail-pm', label: 'Retail Centers' },
    { id: 'office-pm', label: 'Office Buildings' },
    { id: 'industrial-pm', label: 'Industrial Properties' },
    { id: 'portfolio-pm', label: 'Portfolio Management' }
  ];

  const commercialPropertyTypes = [
    { id: 'office', label: 'Office Space' },
    { id: 'retail', label: 'Retail Properties' },
    { id: 'industrial', label: 'Industrial & Warehouse' },
    { id: 'multifamily', label: 'Multifamily Properties' },
    { id: 'hospitality', label: 'Hospitality & Hotels' },
    { id: 'investment', label: 'Investment Properties' }
  ];

  const transactionVolumeOptions = [
    { value: 'small', label: 'Small Scale', description: 'Under $10M annually' },
    { value: 'medium', label: 'Medium Scale', description: '$10M - $50M annually' },
    { value: 'large', label: 'Large Scale', description: '$50M - $200M annually' },
    { value: 'institutional', label: 'Institutional Scale', description: '$200M+ annually' }
  ];

  const getPropertyTypesForTrack = () => {
    switch (realEstateTrack) {
      case 'development': return developmentPropertyTypes;
      case 'property-management': return propertyManagementTypes;
      case 'commercial': return commercialPropertyTypes;
      default: return [];
    }
  };

  const handlePropertyTypeToggle = (typeId) => {
    const newTypes = propertyTypes?.includes(typeId)
      ? propertyTypes?.filter(t => t !== typeId)
      : [...propertyTypes, typeId];
    onPropertyTypesChange(newTypes);
  };

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Real Estate Specialization
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        Share your real estate expertise and transaction experience
      </p>
      <div className="space-y-6">
        <Select
          label="Primary Real Estate Track"
          description="Select your main area of real estate expertise"
          options={realEstateTrackOptions}
          value={realEstateTrack}
          onChange={onRealEstateTrackChange}
          required
        />

        {realEstateTrack && (
          <>
            <CheckboxGroup label="Property Types & Expertise">
              {getPropertyTypesForTrack()?.map((type) => (
                <Checkbox
                  key={type?.id}
                  label={type?.label}
                  checked={propertyTypes?.includes(type?.id)}
                  onChange={() => handlePropertyTypeToggle(type?.id)}
                />
              ))}
            </CheckboxGroup>

            <Select
              label="Transaction Volume"
              description="Typical annual transaction or portfolio value"
              options={transactionVolumeOptions}
              value={transactionVolume}
              onChange={onTransactionVolumeChange}
              required
            />
          </>
        )}

        <div className="p-4 md:p-6 rounded-xl bg-muted">
          <p className="text-sm md:text-base text-muted-foreground">
            <strong className="text-foreground">Confidentiality:</strong> All property details and transaction information remain completely anonymous. We focus on your expertise level and deal complexity.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RealEstateQuestionnaire;